export const Animations: { [key: string]: any } = {
  hamburger: require("./json/hamburger.json"),
  openclosemenu: require("./json/openclosemenu.json"),
};
